// extracted by mini-css-extract-plugin
module.exports = {"stat_callout":"_hcp-stat-callout_stat_callout___rejb","copy":"_hcp-stat-callout_copy__V7gC2","purple":"_hcp-stat-callout_purple__7Iy69","orange":"_hcp-stat-callout_orange__iTLAJ"};